// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___2-hzQ","default":"styles-module__default___1FDg9","head3":"styles-module__head3___2QAvU"};